/** Responsive breakpoints (px). Single source of truth for device classification. */
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
} as const;
